export default {
  namespaced: true,
  state: {
    showOnboardingWelcomePopup: localStorage.getItem('showOnboardingWelcomePopup') !== 'false',
    showOnboardingDashboard: localStorage.getItem('onboardingDashboardFinished') !== 'true',
    confirmClosingOnboardingDashboard: false,
    currentOnboardingStep: 0,
    currentOnboardingCard: 'order-sales-menu-section',
    isOnboardingActive: false,
    isConfirmClosePopupShown: false,
  },
  getters: {
    currentOnboardingStep: (state) => state.currentOnboardingStep,
    currentOnboardingCard: (state) => state.currentOnboardingCard,
    isOnboardingActive: (state) => state.isOnboardingActive,
  },
  mutations: {
    CLOSE_WELCOME_ONBOARDING_POPUP(state) {
      state.showOnboardingWelcomePopup = false
      localStorage.setItem('showOnboardingWelcomePopup', 'false')
    },
    TOGGLE_CONFIRM_CLOSING_ONBOARDING_DASHBOARD(state) {
      state.confirmClosingOnboardingDashboard = !state.confirmClosingOnboardingDashboard
    },
    CLOSE_ONBOARDING_DASHBOARD(state) {
      state.confirmClosingOnboardingDashboard = false
      state.showOnboardingDashboard = false

      state.isConfirmClosePopupShown = false
      localStorage.setItem('onboardingDashboardFinished', 'true')
    },
    SET_CURRENT_STEP(state, step) {
      state.currentOnboardingStep = step
    },
    SET_CURRENT_CARD(state, card) {
      state.currentOnboardingCard = card
    },
    SET_ONBOARDING_ACTIVITY(state, status) {
      state.isOnboardingActive = status
    },
    SET_ONBOARDING_CLOSE_POPUP(state, status) {
      state.isConfirmClosePopupShown = status
    },
  },
  actions: {
    setCurrentStep: ({ commit }, payload) => {
      commit('SET_CURRENT_STEP', payload)
    },
    setCurrentCard: ({ commit }, payload) => {
      commit('SET_CURRENT_CARD', payload)
    },
    setOnboardingActivity: ({ commit }, payload) => {
      commit('SET_ONBOARDING_ACTIVITY', payload)
    },
    finishOnboarding: ({ commit, rootState }) => {
      commit('CLOSE_ONBOARDING_DASHBOARD', rootState)
    },
    showOnboardingClosePopup: ({ commit }) => {
      commit('SET_ONBOARDING_CLOSE_POPUP', true)
    },
    hideOnboardingClosePopup: ({ commit }) => {
      commit('SET_ONBOARDING_CLOSE_POPUP', false)
    },
  },
}
